import React from "react";

const PageTwo = () => {
    return <h1>Page Two</h1>;
};

export default PageTwo;
